<template>
  <transition v-cloak name="modal">
    <v-modal data-test="login-oos-modal" :is-open="showOutOfServiceModal" @close="close">
      <template #title>
        <h2>
          {{ title }}
        </h2>
      </template>
      <template #content>
        <p v-html="text" />
      </template>
      <template #buttons>
        <button class="button large" @click="close">
          {{ buttonText }}
        </button>
      </template>
    </v-modal>
  </transition>
</template>

<script>
export default {
  name: 'LoginOutOfServiceNotification',

  props: {
    title: {
      type: String,
      default() {
        return '';
      }
    },
    text: {
      type: String,
      default() {
        return '';
      }
    },
    buttonText: {
      type: String,
      default() {
        return '';
      }
    },
    iditState: {
      type: String,
      default() {
        return '';
      }
    }
  },
  data() {
    return {
      showOutOfServiceModal: false
    };
  },
  mounted() {
    this.showOutOfServiceModal = this.iditState === 'Unavailable';
  },
  methods: {
    close() {
      this.showOutOfServiceModal = false;
    }
  }
};
</script>
